var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5432 8.35696C15.3294 6.73175 14.112 5.87931 14.0608 5.84382L13.8846 5.72175V8.45446C13.8846 8.85289 13.5574 9.17592 13.1538 9.17592C12.7503 9.17592 12.4231 8.85289 12.4231 8.45446V7.30011C12.4231 4.08383 10.3725 2.05008 9.85134 1.49629C9.85134 1.49629 9.09354 0.748144 8.71464 0.374072C8.33575 0 7.95685 0 7.95685 0L7.98911 1.08606C7.9648 2.9078 6.26113 5.57991 3.19185 8.6101C0.94712 10.8262 -0.00741055 12.9307 4.32975e-05 15.647C0.00696125 18.1533 1.02361 20.515 2.86281 22.2968C4.66581 24.0436 7.01796 25 9.50175 25C9.5531 25 9.60474 24.9996 9.65619 24.9988C12.1609 24.9588 14.5093 23.9657 16.2686 22.2021C18.03 20.4366 19 18.0993 19 15.621C19 13.0206 18.1505 10.5087 16.5432 8.35696Z",
    fill: "url(#paint0_linear_10_1716)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1716",
    x1: 11.0024,
    y1: 25,
    x2: 7.99759,
    y2: -2.22558e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.ef16bcc92b59455bc51cc96e7b11b7bd.svg";
export { ForwardRef as ReactComponent };